import { Injectable } from '@angular/core';
import { UserPermissionsService } from './userpermissions.service';

@Injectable({
	providedIn: 'root',
})
export class PermissionExpressionService {
	constructor(private userPermissionsService: UserPermissionsService) {}

	public hasPermission(expression: string | string[] | null | undefined): boolean {
		if (expression == null) {
			return false;
		}
		const segments = Array.isArray(expression) ? expression : [expression];
		if (segments.length === 0 || segments.some((segment) => !segment)) {
			return false;
		}
		return segments.every((segment) => this.evaluateSegment(segment));
	}

	private evaluateSegment(segment: string): boolean {
		if (segment.includes('|')) {
			const permissions = segment.split('|').map((permission) => permission.trim());
			return permissions.some((permission) => this.userPermissionsService.permissions.includes(permission));
		}
		return this.userPermissionsService.hasPermissions(segment.split('&').map((permission) => permission.trim()));
	}
}
